import { Injectable } from "@angular/core";
import { WorkplaceStorageService } from "../../services/local/workplaces-storage.service";
import { UserStorageService } from "../../services/local/user-storage.service";
import { JSONHelper } from "./json.helper";
import { StringUtilsHelper } from "./strings.helper";
import { BranchOffice } from "../../models/configuration/branchoffice/branche_office.model";

@Injectable({
    providedIn: 'root'
})
export class InfoHelper {

    objWorkplace: any;
    listBranch: any[];
    listProfile: any[];
    logoOrg: string;

    constructor(readonly workplaceStorageService : WorkplaceStorageService, readonly userStorageService: UserStorageService){

    }

    getOrganization() : string{
        let org = "";
        let idOrg = this.workplaceStorageService.getOrgId();
        this.objWorkplace = this.workplaceStorageService.getWorkplaces();
        if(this.objWorkplace) {
            let orgFind = this.objWorkplace.find(elem => elem.organizationId.toString() === idOrg);
            this.listBranch = orgFind.branchOffices;
            org = orgFind.organization;
            this.logoOrg = orgFind.logo;
        }
        return org;
    }
    getBranchOffice(): string{
        let branch = "";
        let branchId = this.workplaceStorageService.getBranchId();
        if (this.listBranch) {
            let branchFind = this.listBranch.find(elem => elem.branchOfficeId.toString() === branchId);
            this.listProfile = branchFind.profiles;
            branch = branchFind.name;
        }
        return branch;
    }
    getProfile(){
        let profile = "";
        let profileId = this.workplaceStorageService.getProfileId();
        if (this.listProfile) {
            let profileFind = this.listProfile.find(elem => elem.id.toString() === profileId)
            profile = profileFind.name;
        }
        return profile;
    }
    getEnableNOM024(){
        let nom024: boolean = false;
        let branchId = this.workplaceStorageService.getBranchId();
        if (this.listBranch) {
            let branchFind = this.listBranch.find(elem => elem.branchOfficeId.toString() === branchId);
            nom024 = branchFind.activationNOM024Enabled;
        }
        return nom024;
    }
    getLogoOrganization(){
        return this.logoOrg;
    }
    getIdUser(){
        return this.userStorageService.getIdUser();
    }
    getUsername(){
        return this.userStorageService.getUsername();
    }
    getFullname(){
        return this.userStorageService.getFullName();
    }
    getPhotoProfileUser(){
        return "";
    }
    getIdOrg(){
        return this.workplaceStorageService.getOrgId();
    }
    getIdBranch(){
        return this.workplaceStorageService.getBranchId();
    }
    getBranchOfficeId(){
        return this.workplaceStorageService.getBranchId();
    }
    getIdProfile(){
        return this.workplaceStorageService.getProfileId();
    }

    getUnitId(){
        let unitId: number = 0;
        let data = WorkplaceStorageService.getPatientData();
        if (StringUtilsHelper.notNullOrUndefinedOrEmpty(data)) {
            let obj = JSONHelper.getDataByKey(data, "obj");
            if(StringUtilsHelper.notNullOrUndefinedOrEmpty(obj)){
                if(StringUtilsHelper.notNullOrUndefinedOrEmpty(obj.unitId))
                    unitId = obj.unitId;
            }
        }
        return unitId;
    }
    getSpecialityIdByData(){
        let specialityId: number = 0;
        let data = WorkplaceStorageService.getPatientData();
        if (StringUtilsHelper.notNullOrUndefinedOrEmpty(data)) {
            let obj = JSONHelper.getDataByKey(data, "obj");
            if(StringUtilsHelper.notNullOrUndefinedOrEmpty(obj)){
                if(StringUtilsHelper.notNullOrUndefinedOrEmpty(obj.specialityId))
                    specialityId = obj.specialityId;
            }
        }
        return specialityId;
    }

    getBranchClues(branchList: BranchOffice[]): string {
        let clues = '';
        const branchId = this.workplaceStorageService.getBranchId();

        if (branchList && branchId) {
            const branch = branchList.find(
                b => b.branchOfficeId.toString() === branchId.toString()
            );
            console.log('Sucursal encontrada:', branch);
            clues = branch?.clues || '';
        }

        return clues;
    }
}
